import React from "react";
import './statement-of-deviation-or-variation.css'

import useMeta from '../../../hooks/useMeta'

import { Link } from "react-router-dom";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

const StatementOfDeviationOrVariation = () => {

    useMeta({
        title: 'Statement of Deviation or Variation | Marvel Blinds',
        description: "Statement of Deviation or Variation 31032025 Statement of Deviation or Variation 30092024",
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/statement-of-deviation-or-variation`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Statement of Deviation or Variation',
            description: "Statement of Deviation or Variation 31032025 Statement of Deviation or Variation 30092024",
            url: `${process.env.REACT_APP_WEBSITE_URL}/statement-of-deviation-or-variation`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="SDV_pg_container">
                <h1 className="SDV_pg_title">Statement of Deviation or Variation</h1>
                <table className="SDV_content_table">
                    <tbody>
                        <tr>
                            <td>
                                <Link target="__blank" to="/Documnets/2025.pdf" >
                                    Statement of Deviation or Variation 31032025
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="border-top-none">
                                <Link target="__blank" to="/Documnets/2024.pdf" >
                                    Statement of Deviation or Variation 30092024
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default StatementOfDeviationOrVariation;